import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	ChangeDetectorRef,
	ViewChild,
	ElementRef
} from "@angular/core";
import { GlobalService } from "../../../services/global/global.service";
import { Observable } from "rxjs";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";
import { TagCatalogResponse } from "src/app/models/dmv/tagCatalogResponse";
import { TagCatalog } from "src/app/models/dmv/tagCatalog";
import { Tag } from "src/app/models/dmv/tag";
import { TagImageCodeXref } from "src/app/models/dmv/tagImageCodeXref";
import { AppUtil } from "../../../utils/app.util";
import { DmvFee } from "src/app/models/dmv/dmvFee";
import { Registration } from "src/app/models/dmv/registration";
import { DmvRegistration } from "src/app/models/dmv/dmvRegistration";
import { TagCategories } from "src/app/models/dmv/tagCategories";

declare var $: any;

@Component({
	selector: "dmv-overlay-plate",
	templateUrl: "./overlay-plate.component.html",
	styleUrls: ["./overlay-plate.component.css"],
	host: {
		"(document:click)": "onClick($event)"
	}
})
export class OverlayPlateComponent implements OnInit {
	constructor(
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		private cd: ChangeDetectorRef
	) {}
	@ViewChild("selectOverlayDropdown", { static: false })
	selectOverlayDropdown: ElementRef;
	public isPopupOpen: boolean = true;
	public tagCategoryID: number = 0;
	public tagCatalog: TagCatalog;
	public tagCatalogId: number = 0;
	public tag: Tag;
	public currentTag: Tag;
	public filterTagCatalogData: TagCatalog;
	public isDropdownOpen: boolean = false;
	public errorMessage: string;
	public tagImageCodeXref: TagImageCodeXref;
	public tagItemShowHide: Map<string, boolean> = new Map();
	@Input() public allowSpecialtyTag: boolean;
	@Input() public plateData: any;
	@Input() public currentTagCode: string;
	@Output() public closeOverlay: EventEmitter<any> = new EventEmitter();
	@Input() public registrationNumber: number;
	@Output() public changePlateEvent: EventEmitter<any> = new EventEmitter();
	@Output() public changePlateNo: EventEmitter<any> = new EventEmitter();
	@Output() public changePlateYes: EventEmitter<any> = new EventEmitter();
	public DMVRegistration: DmvRegistration;
	public tagCategories: TagCategories;
	ngOnInit() {
		AppUtil.log("OverlayPlateComponent ngOnInit() == >");
		this.DMVRegistration = this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		];
		this.errorMessage = null;
		this.dmvStoreService.tagCatalogData$.subscribe(tagCatalogResponse => {
			if (tagCatalogResponse) {
				if (
					tagCatalogResponse["status"] &&
					tagCatalogResponse["status"] !== 200
				) {
					this.errorMessage = this.dmvStoreService.agencyConfig.agencyDmvConfig.systemFailureText;
					this.cd.markForCheck();
					window.scrollTo(0, 0);
				} else {
					this.setOldAnualFee(tagCatalogResponse.tagCatalog);
					this.tagCatalog = tagCatalogResponse.tagCatalog;
					this.tagCategories = this.filterDataByRegistration(
						tagCatalogResponse.tagCategories
					);
					this.tagImageCodeXref = tagCatalogResponse.tagImageCodeXref;
					this.filterCatalog();
					if (this.tagCategories.length > 0) {
						const id =
							this.currentTag && this.currentTag.tagCategoryID
								? this.currentTag.tagCategoryID
								: this.tagCategories[0].tagCategoryID;
						this.filterTagCatalog(this.tagCatalog, id);
						this.tag =
							this.currentTag && this.currentTag
								? this.currentTag
								: this.filterTagCatalogData[0];
					}
				}
			}
		});
	}
	public getImage(tagCode) {
		AppUtil.log("OverlayPlateComponent getImage() == >", tagCode);
		let code: string = "";
		this.tagImageCodeXref.forEach(xref => {
			if (xref.tagCode === tagCode) {
				code = xref.imageCode;
			}
		});
		return code;
	}
	public setOldAnualFee(tags: TagCatalog) {
		const imageCode = this.DMVRegistration.oldImageCode;
		const tag: Tag[] = tags.filter(function(item) {
			return item.imageCode === imageCode;
		});
		this.DMVRegistration.oldAnnualFee = tag[0] ? tag[0].annualFee : 0;
	}
	public filterDataByRegistration(tagCategories) {
		//targetRegistrationType
		//grossWeightOp
		//grossWeight

		const registrationType = this.DMVRegistration.registration.registrationType;
		const grossWeight = this.DMVRegistration.registration.grossWeight;
		if (registrationType) {
			tagCategories = tagCategories.filter(function(item) {
				return (
					item.targetRegistrationType &&
					item.targetRegistrationType.split(",").indexOf(registrationType) > -1
				);
			});
		}

		if (grossWeight) {
			tagCategories = tagCategories.filter(function(item) {
				if (item.grossWeightOp) {
					const grossWeightArray = grossWeight.split(" ");
					if (item.grossWeightOp === grossWeightArray[0].trim()) {
						return item.grossWeightOp === "GT"
							? Number(grossWeightArray[1].trim()) > item.grossWeight
							: Number(grossWeightArray[1]) < item.grossWeight;
					} else {
						return false;
					}
				} else {
					return true;
				}
			});
		}
		AppUtil.log(
			"OverlayPlateComponent filterDataByRegistration() == >",
			tagCategories
		);
		return tagCategories;
	}
	public filterTagCatalog(tags, id) {
		AppUtil.log("OverlayPlateComponent filterTagCatalog() == >", tags, id);
		//registration.isInCart = false;
		const tagsById = tags.filter(function(item) {
			return item.tagCategoryID === id && item.showToUser === true;
		});
		this.filterTagCatalogData = tagsById;
	}

	public showHide(id) {
		this.tagItemShowHide.set(id, !this.tagItemShowHide.get(id));
		event.stopPropagation();
	}
	public changeCatagory(event) {
		AppUtil.log("OverlayPlateComponent changeCatagory() == >", event);
		const id = parseInt(event.target.value);
		this.filterTagCatalog(this.tagCatalog, id);
		this.tag = this.filterTagCatalogData[0];
		this.isDropdownOpen = false;
	}
	public filterCatalog() {
		const currentTagCode = this.currentTagCode;
		const currentTag = this.tagCatalog.filter(function(item) {
			return item.tagCode === currentTagCode;
		});
		this.currentTag = currentTag[0];
	}

	public setDownIcon(event) {
		if (
			event.target &&
			event.target.offsetParent &&
			event.target.offsetParent.classList
		) {
			event.target.offsetParent.classList.remove("upArrow");
		}
	}
	public selectChangeByKey(event) {
		if (event.code === "Enter" || event.code === "Space") {
			this.selectChange(event);
		}
	}
	public selectChange(event) {
		if (
			event.target &&
			event.target.offsetParent &&
			event.target.offsetParent.classList
		) {
			if (!event.target.offsetParent.classList.contains("upArrow")) {
				event.target.offsetParent.classList.add("upArrow");
			} else {
				event.target.offsetParent.classList.remove("upArrow");
			}
		}
	}

	public openDropDown(isDropdownOpen) {
		this.isDropdownOpen = !isDropdownOpen;
		this.cd.detectChanges();
		this.selectOverlayDropdown.nativeElement.scroll(0, 0);
	}

	public changeCatalog(id) {
		AppUtil.log("OverlayPlateComponent changeCatalog() == >", id);
		//	const id = event.target.value;
		this.filterTag(this.filterTagCatalogData, id);
		this.isDropdownOpen = false;
	}
	public filterTag(tags, id) {
		AppUtil.log("OverlayPlateComponent filterTag() == >", tags, id);
		//registration.isInCart = false;
		const tagById = tags.filter(function(item) {
			return item.tagCode === id;
		});
		this.tag = tagById[0];
	}
	public close() {
		this.isPopupOpen = false;
		this.closeOverlay.emit();
	}
	public change() {
		this.changePlateEvent.emit(this);
	}

	public yes() {
		this.isPopupOpen = false;
		this.changePlateYes.emit(this);
	}
	public no() {
		this.isPopupOpen = false;
		this.changePlateNo.emit(this);
	}
	onClick(event) {
		if (
			event.target.id === "select-overlay-input" ||
			event.target.classList.contains("tagImageInput")
		) {
			//this.isDropdownOpen = !this.isDropdownOpen;
		} else {
			this.isDropdownOpen = false;
		}
	}
}
